export enum ProgressStatusType {
    Completed = 'Completed',
    Failed = 'Failed'
}
